const data = {
  title: "Floor 3-3",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 11,
  tilesHeight: 11,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 6
    },
    {
      type: "WATER",
      x: 7,
      y: 6
    },
    {
      type: "WATER",
      x: 6,
      y: 7
    },
    {
      type: "ICE",
      x: 7,
      y: 4
    },
    {
      type: "ICE",
      x: 6,
      y: 4
    },
    {
      type: "ICE",
      x: 8,
      y: 6
    },
    {
      type: "ICE",
      x: 8,
      y: 7
    },
    {
      type: "ICE",
      x: 6,
      y: 8
    },
    {
      type: "ICE",
      x: 4,
      y: 5
    },
    {
      type: "WALL",
      x: 9,
      y: 4
    },
    {
      type: "WALL",
      x: 11,
      y: 4
    },
    {
      type: "WALL",
      x: 9,
      y: 8
    },
    {
      type: "WALL",
      x: 11,
      y: 8
    },
    {
      type: "WALL",
      x: 8,
      y: 11
    },
    {
      type: "WALL",
      x: 3,
      y: 4
    },
    {
      type: "WALL",
      x: 1,
      y: 4
    },
    {
      type: "WALL",
      x: 1,
      y: 8
    },
    {
      type: "ICE",
      x: 5,
      y: 9
    },
    {
      type: "ICE",
      x: 5,
      y: 10
    },
    {
      type: "ICE",
      x: 6,
      y: 9
    },
    {
      type: "ICE",
      x: 7,
      y: 9
    },
    {
      type: "ICE",
      x: 9,
      y: 7
    },
    {
      type: "ICE",
      x: 10,
      y: 7
    },
    {
      type: "ICE",
      x: 11,
      y: 6
    },
    {
      type: "ICE",
      x: 9,
      y: 6
    },
    {
      type: "ICE",
      x: 3,
      y: 5
    },
    {
      type: "ICE",
      x: 2,
      y: 5
    },
    {
      type: "ICE",
      x: 1,
      y: 6
    },
    {
      type: "ICE",
      x: 3,
      y: 6
    },
    {
      type: "ICE",
      x: 3,
      y: 7
    },
    {
      type: "WATER_PICKUP",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 11,
      y: 7,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "ICE",
      x: 1,
      y: 5,
      corner: "TOP_LEFT"
    },
    {
      type: "ICE",
      x: 11,
      y: 5,
      corner: "TOP_RIGHT"
    },
    {
      type: "ICE",
      x: 1,
      y: 7,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 9,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 6
    },
    {
      type: "CHIP",
      x: 10,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 5
    },
    {
      type: "ICE",
      x: 5,
      y: 2
    },
    {
      type: "ICE",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 3
    },
    {
      type: "ICE",
      x: 6,
      y: 1
    },
    {
      type: "ICE",
      x: 5,
      y: 1,
      corner: "TOP_LEFT"
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 2,
      direction: "LEFT"
    },
    {
      type: "THIEF",
      x: 4,
      y: 10
    },
    {
      type: "ICE",
      x: 7,
      y: 1,
      corner: "TOP_RIGHT"
    },
    {
      type: "WALL",
      x: 8,
      y: 1
    },
    {
      type: "WATER",
      x: 9,
      y: 10
    },
    {
      type: "WATER",
      x: 9,
      y: 9
    },
    {
      type: "WATER",
      x: 10,
      y: 10
    },
    {
      type: "WATER",
      x: 11,
      y: 9
    },
    {
      type: "WATER",
      x: 11,
      y: 10
    },
    {
      type: "WATER",
      x: 11,
      y: 11
    },
    {
      type: "WATER",
      x: 10,
      y: 11
    },
    {
      type: "WATER",
      x: 9,
      y: 11
    },
    {
      type: "ICE",
      x: 5,
      y: 8
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "THIEF",
      x: 8,
      y: 10
    },
    {
      type: "ICE",
      x: 7,
      y: 10
    },
    {
      type: "ICE",
      x: 7,
      y: 8
    },
    {
      type: "WALL",
      x: 8,
      y: 9
    },
    {
      type: "ICE",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 2,
      y: 7
    },
    {
      type: "ICE",
      x: 6,
      y: 11
    },
    {
      type: "ICE",
      x: 7,
      y: 11,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "WATER",
      x: 5,
      y: 6
    },
    {
      type: "WALL",
      x: 3,
      y: 8
    },
    {
      type: "WALL",
      x: 4,
      y: 9
    },
    {
      type: "WALL",
      x: 4,
      y: 11
    },
    {
      type: "WALL",
      x: 8,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 4
    },
    {
      type: "WALL",
      x: 4,
      y: 8
    },
    {
      type: "WALL",
      x: 8,
      y: 8
    },
    {
      type: "ICE",
      x: 5,
      y: 11,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 3,
      direction: "RIGHT"
    },
    {
      type: "ICE",
      x: 5,
      y: 4
    },
    {
      type: "WATER",
      x: 6,
      y: 5
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "ICE_BOOTS",
      x: 2,
      y: 10
    },
    {
      type: "ICE",
      x: 10,
      y: 6
    },
    {
      type: "ICE",
      x: 10,
      y: 5
    },
    {
      type: "THIEF",
      x: 2,
      y: 6
    },
    {
      type: "WATER",
      x: 5,
      y: 5
    },
    {
      type: "WATER",
      x: 5,
      y: 7
    },
    {
      type: "WATER",
      x: 7,
      y: 5
    },
    {
      type: "WATER",
      x: 7,
      y: 7
    },
    {
      type: "LOCK",
      x: 10,
      y: 4,
      color: "GREEN"
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 4,
      direction: "UP"
    },
    {
      type: "LOCK",
      x: 10,
      y: 8,
      color: "BLUE"
    },
    {
      type: "KEY",
      x: 10,
      y: 2,
      color: "BLUE"
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 9,
      direction: "DOWN"
    },
    {
      type: "WATER_PICKUP",
      x: 6,
      y: 10
    },
    {
      type: "KEY",
      x: 10,
      y: 6,
      color: "GREEN"
    }
  ]
};

export default data;
